import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getChainPositionOptions } from '../../../helpers/chainPosition';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorItem,
  SelectorImageItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { getBaseProductType } from '../../../helpers/getBaseProductType';

type OnClick = (
  chainPosition: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (chainPosition, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      chainPosition,
    },
  });
};

export const ChainPosition = () => {
  const [state, send] = useService(productBuilderMachine);
  const productType = getBaseProductType(state.context);
  const {
    custom: { chainPosition },
  } = state.context;
  const chainPositionOptions = getChainPositionOptions(state.context);

  if (
    isCurrentState('chainPosition', state) &&
    chainPositionOptions.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Chain position</Heading>
      <Selector isSlider={true}>
        {chainPositionOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'chainPosition',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === chainPosition}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
